import { storeWrapper } from '../storeWrapper'
import axios from 'axios'
import { debounce } from '@repo/utils/debounce'

const initialState = {
  newsItems: [],
  dashboardAnnouncements: [],
  loginPromo: null
}

const baseUrl = import.meta.env.VITE_SPA_OSPREY_WORDPRESS_API_URL
const baseUrlSupportSite = import.meta.env.VITE_SPA_OSPREY_SUPPORT_WORDPRESS_API_URL

export const useWordpressStore = storeWrapper('useWordpressStore', (set, get) => ({
  ...initialState,
  fetchNewsItems: async () => {
    // don't fetch if we already have news items
    if (get().newsItems.length) return

    debounce({
      id: `fetchNewsItems`,
      delay: 300,
      callback: async () => {
        let newsItems = []
        try {
          const { data } = await axios.get(`${baseUrl}/wp/v2/posts?_embed&per_page=10&categories_exclude=1551`)
          newsItems = data
        } catch (err) {
          console.error(err)
        }

        set({ newsItems })
      }
    })
  },
  fetchLoginPromo: async () => {
    debounce({
      id: `fetchLoginPromo`,
      delay: 200,
      callback: async () => {
        let loginPromo = null
        try {
          const { data } = await axios.get(`${baseUrl}/osprey/login-promo?useragent=${navigator.userAgent}`)
          loginPromo = `<!DOCTYPE html><html lang="en"><head><title>Osprey Login Promo</title><style>${data.css || ''}</style></head><body style="margin: 0"><div id="promo-content">${data.html || ''}</div></body></html>`
        } catch (err) {
          console.error(err)
        }

        set({ loginPromo })
      }
    })
  },
  fetchDashboardAnnouncements: async () => {
    // don't fetch if we already have dashboardAnnouncements
    if (get().dashboardAnnouncements.length) return

    debounce({
      id: `fetchDashboardAnnouncements`,
      delay: 300,
      callback: async () => {
        let dashboardAnnouncements = []
        try {
          const newEraCategoryId = 285

          const { data } = await axios.get(
            `${baseUrlSupportSite}/wp/v2/pracctice_guide?_embed&per_page=50&categories=${newEraCategoryId}&acf_format=standard`
          )

          // filter item to only include those marked as announcements
          dashboardAnnouncements = data
            ?.filter((item) => item.acf?.display_as_dashboard_announcement)
            .map((item) => {
              const { id, link, acf } = item || {}
              const { announcement_title, announcement_type, announcement_image, announcement_link_text } = acf || {}

              return {
                id,
                link,
                title: announcement_title,
                type: announcement_type || 'New feature',
                image: announcement_image,
                linkText: announcement_link_text || 'Learn more'
              }
            })
        } catch (err) {
          console.error(err)
        }

        set({ dashboardAnnouncements })
      }
    })
  },
  reset: () => set(initialState)
}))
